module.exports = __webpack_public_path__ + "static/media/functionalCoasterWallet-small.37a0b193.jpg";